import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { DatevAccount, IDatevAccount } from "@/models/datev-account.entity";

export const DatevAccountDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<IDatevAccount, ""> {
  getIdentifier(entity: IDatevAccount): string {
    return entity.id;
  }

  mapEntity(entity: IDatevAccount): IDatevAccount {
    return new DatevAccount(entity);
  }
})();
